import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';

import Button from 'app/components/Button';
import { useLang } from 'app/context/i18n';
import { Colors } from 'app/utils/colors';
import Icon from 'app/components/Icon';
import { enableSubscriptionRenew } from 'app/api/my-account/wholesaler-pack/enableSubscriptionRenew';
import { genericRequest } from 'app/api';
import { useDispatch } from 'react-redux';
import { setUser } from 'app/modules/Auth/_redux/AuthActions';
import WholesalerPackCancelPackModal from '../WholesalerPackCancelPackModal';

export const ButtonCancelPack = () => {
  const [showCancelModal, setShowCancelModal] = useState(false);
  const intl = useIntl();

  return (
    <>
      <Button
        onClick={() => setShowCancelModal(true)}
        text={intl.formatMessage({
          id: 'controlpanel.wholesaler_pack.button.cancel'
        })}
        size="big"
      />

      <WholesalerPackCancelPackModal
        show={showCancelModal}
        handleClose={() => setShowCancelModal(false)}
      />
    </>
  );
};

export const ButtonReactivatePack = () => {
  const intl = useIntl();
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();

  const handleReactivatePack = async () => {
    setIsLoading(true);
    const enableSubscription = await enableSubscriptionRenew(intl);

    if (enableSubscription) {
      const newUser = await genericRequest({ url: 'customers/me' });
      dispatch(setUser(newUser.data));
    }

    setIsLoading(false);
  };

  return (
    <Button
      onClick={() => handleReactivatePack()}
      text={intl.formatMessage({
        id: 'controlpanel.wholesaler_pack.button.reactivate'
      })}
      size="big"
      type="primary"
      icon={<Icon icon="cube" size="lg" swapOpacity color={Colors.bbGrey2} />}
      disabled={isLoading}
    />
  );
};

export const ButtonActivatePack = () => {
  const intl = useIntl();
  const locale = useLang();
  const checkoutUrl = `https://www.bigbuy.eu/${locale}/subscription/checkout?idSubscription=32`;
  return (
    <Button
      onClick={() => {
        window.location.href = checkoutUrl;
      }}
      text={intl.formatMessage({
        id: 'controlpanel.pack.active.title'
      })}
      size="big"
      type="primary"
      icon={<Icon icon="cube" size="lg" swapOpacity color={Colors.bbGrey2} />}
    />
  );
};

export const ButtonUpgradePack = () => {
  const intl = useIntl();
  const locale = useLang();
  const checkoutUrl = `https://www.bigbuy.eu/${locale}/subscription/checkout?idSubscription=32`;
  return (
    <Button
      onClick={() => {
        window.location.href = checkoutUrl;
      }}
      text={intl.formatMessage({
        id: 'controlpanel.wholesaler_pack.button.change'
      })}
      size="big"
      type="primary"
      icon={<Icon icon="cube" size="lg" swapOpacity color={Colors.bbGrey2} />}
    />
  );
};

export const ButtonChangePack = ({ primary }) => {
  const intl = useIntl();
  const locale = useLang();
  const checkoutUrl = `https://www.bigbuy.eu/${locale}/subscription/checkout?idSubscription=32`;
  return (
    <Button
      onClick={() => {
        window.location.href = checkoutUrl;
      }}
      text={intl.formatMessage({
        id: 'controlpanel.wholesaler_pack.button.change'
      })}
      size="big"
      type={primary ? 'primary' : 'default'}
      icon={
        primary ? (
          <Icon icon="cube" size="lg" swapOpacity color={Colors.bbGrey2} />
        ) : null
      }
    />
  );
};

ButtonChangePack.propTypes = {
  primary: PropTypes.bool
};
